var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["to-top", { visible: _vm.isVisible }],
      on: { click: _vm.scrollToTop }
    },
    [
      _c("f-sprite-icon", {
        attrs: { "icon-link": _vm.$options.icons.IconArrow.id }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }